import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navbar.css';
import logo from '../assets/images/logo.png';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation(); // 🔥 saber en qué página estás

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path ? 'active-link' : '';

  return (
    <>
      <header className={`navbar ${scrolled ? 'active' : ''}`}>
        <div className="navbar-container">

          <div className="logo">
            <Link to="/">
              <img src={logo} alt="COPAC" />
            </Link>
          </div>

          <div className="hamburger" onClick={() => setMenuOpen(true)}>
            ☰
          </div>

          <nav className="desktop-menu">
            <Link className={isActive('/')} to="/">Inicio</Link>
            <Link className={isActive('/somos')} to="/somos">Somos</Link>
            <Link className={isActive('/productos')} to="/productos">Productos</Link>
            <Link className={isActive('/contacto')} to="/contacto">Contáctanos</Link>
          </nav>

        </div>
      </header>

      <div
        className={`overlay-menu ${menuOpen ? 'show' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>Inicio</Link>
        <Link to="/somos" onClick={() => setMenuOpen(false)}>Somos</Link>
        <Link to="/productos" onClick={() => setMenuOpen(false)}>Productos</Link>
        <Link to="/contacto" onClick={() => setMenuOpen(false)}>Contáctanos</Link>
      </div>
    </>
  );
}

export default Navbar;